import { ArrowDown } from "lucide-react";
import { motion } from "framer-motion";
import { ProductPhone } from "./FeatureSection";
import { smoothScrollTo } from "../../lib/scroll";

const SCREENS = [
  ["ai-chat", "HUMN Ai intention screen"],
  ["feed", "HUMN discovery feed"],
  ["happenings", "My Happenings workspace"],
  ["profile", "HUMN profile and trust"],
  ["wallet", "HUMN Credits wallet"],
];

export const FeaturesHero = () => (
  <section className="features-hero v2-dots" data-testid="features-hero-section">
    <div className="features-hero-glow" aria-hidden="true" />
    <div className="features-shell features-hero-copy">
      <motion.img src="/brand/humn-mark.png" alt="" aria-hidden="true" className="features-hero-mark" initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} />
      <motion.p className="feature-index" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>THE PRODUCT, IN MOTION</motion.p>
      <motion.h1 initial={{ opacity: 0, y: 28 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: .08 }} data-testid="features-hero-title">EVERYTHING YOU CAN<br />MAKE HAPPEN<br /><em>WITH HUMN</em></motion.h1>
      <motion.p className="features-hero-lead" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: .16 }}>One Ai Social Network.<br />Different ways to turn intentions into real actions.</motion.p>
      <motion.p className="features-hero-verbs" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: .28 }}>Discover. Connect. Learn. Join. Ask. Explore. Create.</motion.p>
      <button type="button" className="features-explore-button" data-testid="features-hero-explore-button" onClick={() => smoothScrollTo(document.getElementById("feature-selector"))}>Explore the Product <ArrowDown size={17} /></button>
    </div>
    <div className="features-screen-rail" data-testid="features-hero-screen-strip">
      {SCREENS.map(([name, alt], index) => <ProductPhone key={name} src={`/app-screens/${name}.jpg`} alt={alt} testId={`features-hero-phone-${name}`} rotate={(index - 2) * 2} />)}
    </div>
  </section>
);